module.exports = __webpack_public_path__ + "static/media/bath-dungeon-of-doom.b61eb41d.md";